import { initialState } from "./state"

export default {
  setListOffersCombo: (state, payload) => (state.listOffersCombo = payload),
  setOptionsOffersCombo: (state, payload) =>
    (state.optionsOffersCombo = payload),
  setPaginationOffersCombo: (state, payload) =>
    (state.paginationOffersCombo = payload),

  resetOffersCombo: state => {
    const init_state = initialState()
    Object.assign(state, init_state)
  },
  setCurrentPage: (state, payload) => (state.currentPage = payload),
  setCombosFilter: (state, payload) => (state.combosFilter = payload),
  setCombosFilterToInitial: state =>
    (state.combosFilter = initialState().combosFilter)
}
